@for (element of mapOverlay; track element; let i = $index) {
  <div
    class="mapOverlayDefault"
    [ngClass]="element.cssClass"
    [style.position]="element.fixed ? 'fixed' : 'absolute'"
    [style.marginLeft]="element.marginLeft"
    [style.marginRight]="element.marginRight"
    [style.marginTop]="element.marginTop"
    [style.marginBottom]="element.marginBottom"
    [style.fontSize]="element.fontSize"
  >
    @if (element.link) {
      <a target="_blank" [href]="element.link">
        {{ element.text }}
        @if (element.imgSrc) {
          <img
            [src]="element.imgSrc"
            [alt]="element.alt"
            [ngStyle]="{ width: element.imgSize }"
          />
        }
      </a>
    } @else {
      {{ element.text }}
      @if (element.imgSrc) {
        <img
          [src]="element.imgSrc"
          [alt]="element.alt"
          [ngStyle]="{ width: element.imgSize }"
        />
      }
    }
  </div>
}
